/**
 * EventIncompleteContainerGroupGate
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import ContainerGroupRequest from '../../../ContainerGroupRequest';

// Selectors
import { makeSelectIncompleteContainerGroupId } from './selectors';

interface Props {
    incompleteContainerGroupId?: number;
    children: React.Node;
    FallbackComponent: React.Node;
}

export class EventIncompleteContainerGroupGate extends React.PureComponent<Props> {
    render() {
        const {
            children,
            incompleteContainerGroupId,
            FallbackComponent
        } = this.props;
        if (incompleteContainerGroupId) {
            return (
                <React.Fragment>
                    <ContainerGroupRequest
                        containerGroupId={incompleteContainerGroupId}
                    />
                    {FallbackComponent}
                </React.Fragment>
            );
        }

        return children || null;
    }
}

const mapStateToProps = createStructuredSelector({
    incompleteContainerGroupId: makeSelectIncompleteContainerGroupId()
});

export default connect(mapStateToProps)(EventIncompleteContainerGroupGate);
